import { nprogressRequestInterceptor, nprogressErrorInterceptor, nprogressResponseInterceptor } from '@/jbi-shared/axios-interceptors/axios-loading.interceptor';
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

export default () => {
    // Route API calls through the proxy so the proxy injects trusted user identity
    axios.defaults.baseURL = `${process.env.VUE_APP_PROXY_CLIENT_URL}${process.env.VUE_APP_BCM_API_PATH}`;
    // Enable sending of credentials (cookies) for proxy session
    axios.defaults.withCredentials = true;
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    // Add nprogress interceptors
    axios.interceptors.request.use(
        nprogressRequestInterceptor as (value: InternalAxiosRequestConfig<any>) => InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>>,
        nprogressErrorInterceptor
    );
    axios.interceptors.response.use(
        nprogressResponseInterceptor as (value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>,
        nprogressErrorInterceptor
    );
}

